import fetchClient from "api/client";
import SCHEDULED_REPORTS_ENDPOINT from "./scheduledReportsEndpoint";

/**
 * @description POST /api/report-schedules
 * @param {object} payload - The payload object.
 * @param {object} payload.body - The rule data to be created.
 * @returns {Promise}
 */
export default function createScheduledReport({ body }) {
  const url = `${SCHEDULED_REPORTS_ENDPOINT}`;

  return fetchClient.post(url, { body });
}
